import pager from '@apps-common/js-client/api/pager';
import request from '@apps-common/js-client/api/request';
import {createApi, retry} from '@reduxjs/toolkit/query/react';
import {API_MOSAICS_BASE_PATH} from '../config.js';
import {
  MOSAIC_TYPES,
  getTimeInfo,
  intervals,
  isGlobal,
} from '../util/mosaic.js';

// Inspired by: https://redux-toolkit.js.org/rtk-query/usage/customizing-queries#axios-basequery
const requestBaseQuery = () =>
  retry(
    ({url, method, data, params}) => {
      return request({url: url, method, data, params})
        .then(res => ({data: res.data}))
        .catch(err => {
          return {
            error: {
              satus: err.response?.status,
              data: err.response?.data || err.message,
            },
          };
        });
    },
    {
      maxRetries: 3,
    },
  );
export const apiSlice = createApi({
  baseQuery: requestBaseQuery(),
  endpoints: builder => ({
    getMosaics: builder.query({
      queryFn() {
        const mosaics = [];
        const config = {
          url: API_MOSAICS_BASE_PATH,
          method: 'GET',
          params: {
            v: '1.5',
            _page_size: 1000,
          },
          retries: 3,
        };

        const onEach = data => {
          const list = data
            .filter(m => m._links.tiles)
            .map(mosaic => {
              const timeInfo = getTimeInfo(mosaic);
              const type = isGlobal(mosaic) ? 'Global' : 'Regional';
              return {
                ...mosaic,
                type:
                  MOSAIC_TYPES[mosaic.interval] || MOSAIC_TYPES[intervals.None],
                title: `${timeInfo} (${type})`,
              };
            });
          mosaics.push(...list);
        };

        return pager(config, 'mosaics', onEach)
          .then(() => {
            return {data: mosaics};
          })
          .catch(err => {
            return {error: err};
          });
      },
    }),
  }),
});

// Export the auto-generated hook for the query endpoints
export const {useGetMosaicsQuery} = apiSlice;
